<template>
  <base-footer :links="links" :socialLinks="socialLinks" logo="/static-appopensalud/img/logos/openlegal_white.svg" companyName="Openlegal"></base-footer>
</template>

<script>
import es from '@/lang/es/public/footer-openlegal.json'
import en from '@/lang/en/public/footer-openlegal.json'
import BaseFooter from '../../base/BaseFooter.vue'

export default {
  name: 'FooterOpenlegalHome',
  components: {
    BaseFooter
  },
  i18n: {
    messages: {
      es,
      en,
      mx: es
    }
  },
  methods: {
    getRelativeHref (path) {
      return this.$helpers.getRelativeHref(path, 'openlegal')
    }
  },
  data () {
    return {
      socialLinks: [
        {
          href: 'https://www.facebook.com/openlegal.es',
          src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Facebook.svg',
          alt: 'openlegal social facebook'
        },
        {
          href: 'https://www.instagram.com/openlegal_es/',
          src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Instagram.svg',
          alt: 'openlegal social instagram'
        },
        {
          href: 'https://www.linkedin.com/company/openlegalespana/about/?viewAsMember=true',
          src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Linkedin.svg',
          alt: 'openlegal social linkedin'
        },
        {
          href: 'https://www.twitter.com/openlegal_es',
          src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Twitter.svg',
          alt: 'openlegal social twitter'
        }
      ],
      links: {
        firstColumn: [
          {
            text: this.$t('openlegal.home-footer.client-conditions'),
            href: this.getRelativeHref('terms-clients')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-fiscal-tributario'),
            href: this.getRelativeHref('areas/derecho-fiscal-tributario')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-constitucional'),
            href: this.getRelativeHref('areas/derecho-constitucional')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-laboral'),
            href: this.getRelativeHref('areas/derecho-laboral')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-administrativo'),
            href: this.getRelativeHref('areas/derecho-administrativo')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-familia'),
            href: this.getRelativeHref('areas/derecho-familia')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-sucesiones-herencias'),
            href: this.getRelativeHref('areas/derecho-sucesiones-herencias')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-mercantil'),
            href: this.getRelativeHref('areas/derecho-mercantil')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-internacional-privado'),
            href: this.getRelativeHref('areas/derecho-internacional-privado')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-urbano'),
            href: this.getRelativeHref('areas/derecho-urbano')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-bancario'),
            href: this.getRelativeHref('areas/derecho-bancario')
          },
          {
            text: this.$t('openlegal.home-footer.corporate-compliance'),
            href: this.getRelativeHref('areas/corporate-compliance')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-transporte'),
            href: this.getRelativeHref('areas/derecho-transporte')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-privacy'),
            href: this.getRelativeHref('areas/derecho-privacidad')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-consumo'),
            href: this.getRelativeHref('areas/derecho-consumo')
          }
        ],
        secondColumn: [
          {
            text: this.$t('openlegal.home-footer.propiedad-intelectual'),
            href: this.getRelativeHref('areas/propiedad-intelectual')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-seguridad-social'),
            href: this.getRelativeHref('areas/derecho-seguridad-social')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-extranjeria'),
            href: this.getRelativeHref('areas/derecho-extranjeria')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-militar'),
            href: this.getRelativeHref('areas/derecho-militar')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-aeronautico'),
            href: this.getRelativeHref('areas/derecho-aeronautico')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-deporte'),
            href: this.getRelativeHref('areas/derecho-deporte')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-menores'),
            href: this.getRelativeHref('areas/derecho-menores')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-ambiental'),
            href: this.getRelativeHref('areas/derecho-ambiental')
          },
          {
            text: this.$t('openlegal.home-footer.arrendamientos-propiedad-horizontal'),
            href: this.getRelativeHref('areas/derecho-arrendamientos')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-civil'),
            href: this.getRelativeHref('areas/derecho-civil')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-penal'),
            href: this.getRelativeHref('areas/derecho-penal')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-internacional-publico'),
            href: this.getRelativeHref('areas/derecho-internacional-publico')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-contratos'),
            href: this.getRelativeHref('areas/derecho-contratos')
          },
          {
            text: this.$t('openlegal.home-footer.pension-alimentos'),
            href: this.getRelativeHref('areas/pension-alimentos')
          },
          {
            text: this.$t('openlegal.home-footer.pension-compensatoria'),
            href: this.getRelativeHref('areas/pension-compensatoria')
          }
        ],
        thirdColumn: [
          {
            text: this.$t('openlegal.home-footer.derecho-hipotecario'),
            href: this.getRelativeHref('areas/derecho-hipotecario')
          },
          {
            text: this.$t('openlegal.home-footer.asistencia-detenido'),
            href: this.getRelativeHref('areas/asistencia-detenido')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-sanitario'),
            href: this.getRelativeHref('areas/derecho-sanitario')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-digital-imagen'),
            href: this.getRelativeHref('areas/derecho-digital-imagen')
          },
          {
            text: this.$t('openlegal.home-footer.derechos-humanos'),
            href: this.getRelativeHref('areas/derechos-humanos')
          },
          {
            text: this.$t('openlegal.home-footer.juicio-delito-leve'),
            href: this.getRelativeHref('areas/juicio-delito-leve')
          },
          {
            text: this.$t('openlegal.home-footer.juicio-rapido'),
            href: this.getRelativeHref('areas/juicio-rapido')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-penitenciario'),
            href: this.getRelativeHref('areas/derecho-penitenciario')
          },
          {
            text: this.$t('openlegal.home-footer.derecho-maritimo'),
            href: this.getRelativeHref('areas/derecho-maritimo')
          }
        ]
      }
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/public/footers/FooterOpenlegalHome.vue